<div *ngIf="reel" class="reel-strip">
  <div class="reel-strip-header" *ngIf="reel.name">
    <div class="reel-name">{{ reel.name }}</div>
    <div class="reel-description" *ngIf="reel.description">{{ reel.description }}</div>
  </div>
  <div class="reel-strip-track">
    <button
      *ngFor="let item of sortedItems; trackBy: trackByArtifactId"
      class="reel-card"
      [class.selected]="item.artifactId === selectedArtifactId"
      (click)="selectItem(item)"
      type="button">
      <div class="reel-card-thumb">
        <img *ngIf="!thumbnailFailed[item.artifactId]"
             [src]="getThumbnailUrl(item)"
             [alt]="item.label"
             loading="lazy"
             (error)="onThumbnailError(item)">
        <div *ngIf="thumbnailFailed[item.artifactId]" class="reel-card-thumb-fallback">
          <mat-icon>{{ getFallbackIcon(item) }}</mat-icon>
        </div>
        <div class="reel-card-selected-indicator">
          <mat-icon>check_circle</mat-icon>
        </div>
      </div>
      <div class="reel-card-label">
        <div class="reel-card-title">{{ item.label }}</div>
        <div class="reel-card-subtitle" *ngIf="item.subtitle">{{ item.subtitle }}</div>
      </div>
    </button>
  </div>
</div>
